import React, { useState } from "react";
import PropTypes from "prop-types";
import { reject } from "lodash";
import LitCard from "../shared/LitCard";

const propTypes = {
  bookmarks: PropTypes.array
};

// This is basically a very trimmed down copy of the `GuideList` component
// in order to reuse existing stylings for lit cards organization.

function EmptyContainer({ browsePath, emptyImgSrc }) {
  return (
    <div className="bookmarks-container__empty">
      <img
        alt="save guide illustration"
        className="bookmarks-empty__image"
        src={emptyImgSrc}
      />
      <div className="bookmarks-empty__description">
        <span className="body-1">You haven&apos;t saved any guides yet.</span>
        <span className="body-1">Save your first guide!</span>
      </div>
      <a
        className="btn btn-lg btn-default bookmarks-empty_browse-btn"
        href={browsePath}
      >
        Browse Guides
      </a>
    </div>
  );
}

export default function BookmarkList({
  bookmarks: bookmarksFromProps,
  browsePath,
  emptyImgSrc
}) {
  const [bookmarks, setBookmarks] = useState(bookmarksFromProps);
  const subtitleText =
    bookmarks.length > 1
      ? `Here are the ${bookmarks.length} guides you've saved.`
      : "Here is the 1 guide you've saved.";

  const handleRemoveBookmark = (bookmarkId) => {
    const newBookmarks = reject(
      bookmarks,
      (bookmark) => bookmark.bookmarkId === bookmarkId
    );
    setBookmarks(newBookmarks);
  };

  return (
    <div>
      {bookmarks.length > 0 ? (
        <>
          <div className="bookmarks__subtitle subtitle-1">{subtitleText}</div>
          <div className="guide-list">
            <div className="guide-list__groups-wrapper">
              <ul className="guide-list__groups guide-list__groups--grid">
                <li className="guide-list__group">
                  <ul className="guide-list__guides">
                    <div className="row">
                      {bookmarks.map((bookmark, index) => (
                        <div
                          className="col-xxs-12 col-xs-6 col-sm-6 col-md-4 col-lg-4"
                          key={bookmark.slug}
                        >
                          <li className="guide-list__guide">
                            <LitCard
                              {...bookmark}
                              hideSuccessCta
                              index={index}
                              onRemoval={handleRemoveBookmark}
                              includeTags
                              userSignedIn
                            />
                          </li>
                        </div>
                      ))}
                    </div>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </>
      ) : (
        <EmptyContainer browsePath={browsePath} emptyImgSrc={emptyImgSrc} />
      )}
    </div>
  );
}

BookmarkList.propTypes = propTypes;
